export default {
  psw: "पासवर्ड",
  topFive: "टॉप 5",
  confPsw: "पासवर्डची खात्री करा.",
  newPsw: "नवीन पासवर्ड",
  email: "ईमेल",
  emailId: "ईमेल आयडी",
  submit: "दाखल करा",
  cancel: "रद्द करा",
  dashboard: "डॅशबोर्ड",
  faqs: "एफएक्यू/नेहमीची प्रश्नोत्तरे",
  users: "वापरकर्ते",
  appUser: "ॲप वापरकर्ते",
  app_users: "ॲप वापरकर्ते",
  dimitraAdmin: "दिमीत्रा ॲडमिन",
  admin_users: "ॲडमिन वापरकर्ते",
  autoCondition: "स्वयं स्थिती",
  search: "शोधा",
  searchBy: "शोधा {type}",
  firstName: "नाव",
  lastName: "आडनाव",
  mobile: "मोबाइल",
  mobileNumber: "मोबाईल क्रमांक",
  department: "विभाग",
  role: "भूमिका",
  status: "स्थिती",
  permission: "परवानग्या",
  activity_log: "कार्य नोंदणी",
  profile_auth: "प्रोफाईचे प्रमाणीकरण",
  countryCode: "देशाचा कोड",
  selectDept: "विभाग निवडा",
  selectRole: "भूमिका निवडा",
  edit: "संपादन करा",
  update: "अद्ययावत करा.",
  delete: "काढून टाका.",
  view: "दृष्टीचा टप्पा",
  deactivate: "निष्क्रिय करा",
  activate: "सक्रिय करा",
  serverError: "काही तरी चूक झाली. थोड्या वेळाने पुन्हा प्रयत्न करा.",
  minute: "मिनिट",
  perHour: "प्रति तास",
  day: "दिवस",
  enterDescription: "तुमचे वर्णन येथे प्रविष्ट करा",
  enterHere: "येथे प्रविष्ट करा",
  enterMobile: "मोबाईल क्रमांक प्रविष्ट करा.",
  phoneRequired: "मोबाईल क्रमांक आवश्यक आहे.",
  phoneValid: "मोबाईल क्रमांक वैध असावा.",
  unableToUpdate: "अद्यावत करता येत नाही!",
  membershipPlans: "सभासद योजना",
  byWeek: "आठवड्यानुसार",
  byMonth: "महिन्यानुसार",
  byYear: "वर्षानुसार",
  custom: "स्वनिर्धारण",
  name: "नाव",
  regionState: "प्रांत/राज्य",
  provinceState: "प्रांत/राज्य",
  cityTown: "शहर/गाव",
  membershipValidity: "सभासद वैधता",
  exportAsCSV: "सीएसव्ही फाईल मिळवा",
  filterBy: "या प्रमाणे छानणी करा",
  comingSoon: "लवकरच येत आहे.",
  userRole: "वापरकर्त्याची भूमिका",
  additionalInformationRequired: "अधिक माहिती हवी आहे",
  approve: "मान्य करा",
  reject: "अमान्य करा",
  username: "वापरकर्त्याचे नाव",
  phone: "फोन",
  roleAssigned: "सोपवलेली भूमिका",
  roleRequested: "भूमिकेसाठी विनंती",
  requestedDate: "विनंतीचा दिनांक",
  updateRoleRequest: "भूमिकेची विनंती अद्ययावत करा.",
  message: "संदेश",
  faqSection: {
    createFaq: "एफएक्यूज्/नेहमीची प्रश्नोत्तरे तयार करा.",
    createTopic: "मथळा तयार करा",
    selectTopic: "विषय निवडा",
    faqQuestion: "एफएक्यू प्रश्न",
    faqAnswer: "एफएक्यू उत्तरे",
    uploadImgVid: "चित्र/व्हिडीओ अपलोड करा",
    disInFaq: "एफएक्यू विभागात दर्शवा",
    editFaq: "एफएक्यू संपादित करा",
    topicName: "विषयाचे नाव",
    parentTopic: "मूळ विषय",
    editTopic: "विषय संपादित करा",
    createSection: "Please create section first",
    createTopicFirst: "Please create topic first",
    questionReq: "एफएक्यू प्रश्न आवश्यक आहे",
    answerReq: "एफएक्यू उत्तर आवश्यक आहे",
  },
  reports: {
    male: "पुरुष",
    female: "स्त्री",
    other: "इतर",
    farmerName: "शेतकऱ्याचे नाव",
    farmerProdChart: "शेतकऱ्याच्या उत्पादनाचा तक्ता",
    production: "उत्पादन",
    byProduction: "उत्पादनानुसार",
    byName: "नावानुसार",
    descending: "उतरताक्रम",
    ascending: "चढताक्रम",
    buyingStationProdChart: "खरेदी केंद्र उत्पादन तक्ता",
    buyingStation: "खरेदी केंद्र",
    buyingStationName: "खरेदी केंद्राचे नाव",
    dryMilling: "कोरडे दळणे",
    dryMillingName: "कोरड्या दळण्याचे नाव",
    dryMillingProdChart: "कोरड्या दळण्याचा उत्पादन तक्ता",
    view: "बघा",
    date: "दिनांक",
  },
  traceability: {
    traceability: "ट्रेसेबिलिटी",
    coffeeTraceabilityMngmnt: "कॉफी ट्रेसेबिलिटी व्यवस्थापन",
    traceabilityPage: "ट्रेसेबिलिटी पृष्ठ",
    labelDesigner: "लेबल डिझायनर",
    additionalInformation: "अतिरिक्त माहिती",
    info1:
      "आपल्या उत्पादाच्या अतिरिक्त लोगोंबद्दल माहिती पुरवा. हा माहिती कॉफी ट्रेसेबिलिटी पृष्ठावर सार्वजनिक असेल.",
    addSlogan: "स्लोगन जोडा",
    additionalLogos: "अतिरिक्त लोगोंस",
    title: "शीर्षक",
    description: "वर्णन",
    mapLink: "नकाशा दुवा",
    websiteLink: "वेबसाइट दुवा",
    addMedia: "मिडिया जोडा",
    uploadImageVideo: "चित्र/व्हिडिओ अपलोड करा",
    origin: "मुख्य ठिकाण",
    info2:
      "आपल्या उत्पादाच्या मूळ देशाबद्दल माहिती पुरवा. हा माहिती कॉफी ट्रेसेबिलिटी पृष्ठावर सार्वजनिक असेल.",
    countryImage: "देश चित्र",
    institutionalInfo: "संस्थागत माहिती",
    info3:
      "आपल्या कंपनी/सहकार्याबद्दल माहिती पुरवा, उपभोक्त्यांना आपल्याकडून केलेल्या संबंधित कामांच्या बद्दल सांगा. हा माहिती कॉफी ट्रेसेबिलिटी पृष्ठावर सार्वजनिक असेल.",
    cooperativeLogo: "सहकारी लोगो",
    traceabilityIntro: "ट्रेसेबिलिटी ओळख",
    info4:
      "हा विभाग उपभोक्त्याला कॉफीच्या संपूर्ण उत्पादन आणि प्रक्रियांच्या इतिहासाची प्रवेश देणार आहे. आपल्या कंपनी/सहकार्याच्या आणि जगाच्या ट्रेसेबिलिटीच्या महत्त्वाचे वर्णन करा.",
    addLabel: "लेबल जोडा",
    chooseTitle: "शीर्षक निवडा",
    chooseLabelDesign: "लेबल डिझायन टेम्प्लेट निवडा",
    uploadYourLogo: "आपल्या लोगो अपलोड करा",
    info5:
      "मार्गदर्शन: चित्राचा आकार किमान 1000 x 1000 पिक्सेल चौरस असणे आवश्यक आहे. आपण फारक स्पष्ट PNG निवडू शकता ज्यासाठी पृष्ठभूमीच्या रंगांसह समवाद बद्दल आहे.",
    chooseTemplateColors: "टेम्प्लेट रंग निवडा",
    backgroundColor: "पार्श्वभूमी रंग",
    foregroundColor: "मुख्य रंग",
    labelStatus: "लेबल स्थिती",
    inactive: "निष्क्रिय",
    download: "डाउनलोड करा",
    enterLabelTitle: "लेबल शीर्षक प्रविष्ट करा",
  },
  cacaoTraceability: {
    traceability: "ट्रेसेबिलिटी",
    cacaoTraceabilityMngmnt: "कॅकॉ ट्रेसेबिलिटी व्यवस्थापन",
    traceabilityPage: "ट्रेसेबिलिटी पृष्ठ",
    labelDesigner: "लेबल डिझायनर",
    additionalInformation: "अतिरिक्त माहिती",
    info1:
      "आपल्या उत्पादाच्या अतिरिक्त लोगोंबद्दल माहिती पुरवा. हा माहिती कॅकॉ ट्रेसेबिलिटी पृष्ठावर सार्वजनिक असेल.",
    addSlogan: "स्लोगन जोडा",
    additionalLogos: "अतिरिक्त लोगोंस",
    title: "शीर्षक",
    description: "वर्णन",
    mapLink: "नकाशा दुवा",
    websiteLink: "वेबसाइट दुवा",
    addMedia: "मिडिया जोडा",
    uploadImageVideo: "चित्र/व्हिडिओ अपलोड करा",
    origin: "मुख्य ठिकाण",
    info2:
      "आपल्या उत्पादाच्या मूळ देशाबद्दल माहिती पुरवा. हा माहिती कॅकॉ ट्रेसेबिलिटी पृष्ठावर सार्वजनिक असेल.",
    countryImage: "देश चित्र",
    institutionalInfo: "संस्थागत माहिती",
    info3:
      "आपल्या कंपनी/सहकार्याबद्दल माहिती पुरवा, उपभोक्त्यांना आपल्याकडून केलेल्या संबंधित कामांच्या बद्दल सांगा. हा माहिती कॅकॉ ट्रेसेबिलिटी पृष्ठावर सार्वजनिक असेल.",
    cooperativeLogo: "सहकारी लोगो",
    traceabilityIntro: "ट्रेसेबिलिटी परिचय",
    info4:
      "हा विभाग उपभोक्त्याला कॉफीच्या संपूर्ण उत्पादन आणि प्रक्रियांच्या इतिहासाची प्रवेश देणार आहे. आपल्या कंपनी/सहकार्याच्या आणि जगाच्या ट्रेसेबिलिटीच्या महत्त्वाचे वर्णन करा.",
    addLabel: "लेबल जोडा",
    chooseTitle: "शीर्षक निवडा",
    chooseLabelDesign: "लेबल डिझायन टेम्प्लेट निवडा",
    uploadYourLogo: "आपल्या लोगो अपलोड करा",
    info5:
      "मार्गदर्शन: चित्राचा आकार किमान 1000 x 1000 पिक्सेल चौरस असणे आवश्यक आहे. आपण फारक स्पष्ट PNG निवडू शकता ज्यासाठी पृष्ठभूमीच्या रंगांसह समवाद बद्दल आहे.",
    chooseTemplateColors: "टेम्प्लेट रंग निवडा",
    backgroundColor: "पार्श्वभूमी रंग",
    foregroundColor: "मुख्य रंग",
    labelStatus: "लेबल स्थिती",
    inactive: "निष्क्रिय",
    download: "डाउनलोड करा",
    enterLabelTitle: "लेबल शीर्षक प्रविष्ट करा",
  },
  setting: {
    profileAuthSetting: "प्रोफाईल प्रमाणीकरणाच्या सेटिंग्ज",
    logInOutSetting: "लॉग-इन/लॉग-ऑफच्या सेटिंग्ज",
    autoLogout: "आपोआप लॉग-ऑफ",
    unsuccessfulLoginAttempt: "लॉग-इनचा अयशस्वी प्रयत्न",
    unsuccessfulLoginLockPeriod: "लॉग-इनचा अयशस्वी प्रयत्न",
    passCriteriaSetup: "पासवर्ड निकषांची रचना",
    passLength: "पासवर्डची लांबी",
    noUniquePassRequired: "आवश्यक एकमेव पासवर्डस् ची संख्या",
    maxPassAge: "पासवर्डचा कमाल कालावधी",
    acceptableRangeOfChars: "स्वीकार्य वर्णांची व्याप्ती",
    upperCase: "मोठी अक्षरे",
    lowerCase: "लहान अक्षरे",
    numbers: "संख्या",
    specialChars: "विशिष्ट वर्ण",
    uniqueSymbols: "विशिष्ट वर्ण",
    loadingData: "सांख्यिके सादर करीत आहोत....",
    currency: "चलन",
    codeActivationTime: "कोड सक्रिय करण्याची वेळ",
    changeGlobalSetting: "समग्र सेटिंग्ज बदलवा",
    globalSetting: "समग्र सेटिंग्ज",
    generalSetting: "सर्वसाधारण सेटिंग्ज",
    hour: "तास",
    days: "दिवस",
    minutes: "मिनीट्स",
    perDay: "प्रति दिवस",
    perHour: "प्रति तास",
    customised: "स्वनिर्धारित",
  },
  coffeeData: {
    windBreaker: "वात रोधक झाडे",
    horticultureInfo: "उद्यानकृषी झाडे",
    shadeTree: "छायावृक्ष",
    coffeeVariety: "कॉफीचे वाण",
    coffeeSpecies: "कॉफीची प्रजाती",
    updateWindBreaker: "वात रोधक झाडांचा प्रकार अद्ययावत करा",
    addWindBreaker: "नवीन वातप्रतिरोधक झाडाचा प्रकार प्रविष्ट करा.",
    updateHorticultureInfo: "उद्यानकृषी झाडांचा प्रकार अद्ययावत करा",
    addHorticultureInfo: "नवीन उद्यानकृषी झाडांची प्रकार प्रविष्ट करा.",
    updateShadeTree: "छायावृक्षाचा प्रकार अद्ययावत करा",
    addShadeTree: "नवीन सावली झाडाचा प्रकार जोडा",
    updateCoffeeVariety: "कॉफी वाणाचा प्रकार अद्ययावत करा",
    addCoffeeVariety: "कॉफी वाणाचा प्रकार प्रविष्ट करा",
    deleteVarietyTitle: "वाण काढून टाका",
    deleteVarietyMessage: "तुम्हाला हे वाण नक्की काढून टाकायचे आहे का?",
    updateCoffeeSpecie: "कॉफीची प्रजाती अद्ययावत करा.",
    deleteSpecieTitle: "कॉफीची प्रजाती काढून टाका.",
    deleteSpecieMessage: "तुम्हाला ही प्रजाती काढून टाकायची आहे का?",
    addCoffeeSpecie: "नवीन कॉफी प्रजाती प्रविष्ट करा.",
    variety: "वाण",
    selectVariety: "प्रजाती निवडा",
    deleteCoffeeRecord: "तुम्हाला नोंद नक्की काढून टाकायची आहे का?",
    deleteCoffeeData: "कॉफीची सांखिके काढून टाका.",
    topicRequired: "विषयाचे नाव आवश्यक आहे",
    coffeeAddSuccess: "कॉफीची प्रजाती यशस्विरीत्या प्रविष्ट केली",
    treeTypeSuccess: "झाडाचा प्रकार यशस्विरीत्या प्रविष्ट केला",
    treeTypeUpdateSuccess: "झाडाचा प्रकार यशस्विरीत्या अद्ययावत केला",
    coffeeVarietySuccess: "कॉफीचे वाण यशस्विरीत्या प्रविष्ट केले",
    coffeeSpecieSuccess: "कॉफीची प्रजाती यशस्विरीत्या अद्ययावत केली",
    nameRequired: "नाव आवश्यक आहे",
    notFound: "ॲडमिनची कॉफी सांख्यिके आढळली नाहीत",
  },
  plantation: {
    farmerName: "शेतकऱ्याचे नाव",
    phoneNumber: "फोन क्रमांक",
    plantationName: "मळ्याचे नाव",
    farm: "शेत",
    location: "स्थान",
    updatePlantationStatus: "मळ्याची सद्यस्थिती अद्ययावत करा.",
    update: "अद्ययावत करा.",
  },
  dashboardReports: {
    appDataReports: "अ‍ॅप डेटा अहवाल",
    reports: "अहवाल",
  },
  activationKey: {
    enterActivationKey: "नवीन वापरकर्ता नोंदणी करण्यासाठी कृपया सक्रियकरण की प्रविष्ट करा",
    activationKeyLimit: "सक्रियकरण की खूप लहान आहे",
    countryRequired: "देश आवश्यक आहे",
    activationKey: "आतापर्यंत कोणतीही अक्टिव्हेशन किज् निर्माण केली नाही.",
    appointSalesManager: "विक्री व्यवस्थापक नियुक्त करा.",
    appointManager: "विक्री व्यवस्थापक यशस्विरीत्या नियुक्त करण्यात आला.",
    salesManAppSuccess: "येथे आणा व टाका किंवा",
    uploadData: "सोपवलेली सांख्यिके CVS रूपात अपलोड करा",
    uploadUserData: "वापरकर्त्यांच्या सांख्यिकांची फाइल अपलोड करा",
    downloadCsv: "(संरचनेसाठी नमुना सीएसव्ही फाइल डाउनलोड करा)",
    downloadSample: "नमुना फाइल डाउनलोड करा",
    dragDrop: "अभिलेख मोजा",
    browse: "आता पाठवा",
    yourFile: "आता पाठवा",
    incorectFileType: "अक्टिव्हेशन किज् प्रदान करणे",
    somethingWentWrong: "काहीतरी चूक झाली!",
    fileUploadedSuccess: "अक्टिव्हेशन किज् दर्शवा",
    countRecords: "सांख्यिके दर्शवा",
    sendNow: "सांख्किके आढळली नाहीत",
    fileName:
      "अक्टिव्हेशन किज् निर्माण करा चा उपयोग करून अक्टिव्हेशन किज् निर्माण करा.",
    assignActKey: "आतापर्यंत कोणतीही अक्टिव्हेशन किज् निर्माण केली नाही.",
    actKeyAssSucc: "वरील बटण",
    viewActKey: "सदस्यता भूमिका",
    actKeyQuota: "ॲक्टीव्हेशन किज् कोटा",
    genActKey: "निर्माण केलेल्या ॲक्टीव्हेशन किज्",
    remActKey: "उर्वरित ॲक्टीव्हेशन किज्",
    penUsed: "प्रलंबित आणि वापरलेल्या किज्",
    activationKeyAss: "सोपविलेल्या ॲक्टीव्हेशन किज्",
    activationKeyUnass: "न सोपविलेल्या ॲक्टीव्हेशन किज्",
    keysAct: "सक्रिय केलेल्या ॲक्टीव्हेशन किज्",
    uploadedFiles: "अपलोड केलेल्या फाईल्स",
    generateActKey: "ॲक्टिव्हेशन किज् निर्माण करा",
    showData: "किज् सद्यस्थिती",
    noDataFound: "अक्टिव्हेशन किज् ची सूची",
    pleaseGenKey:
      '"अक्टिव्हेशन किज् निर्माण करा" चा उपयोग करून अक्टिव्हेशन किज् निर्माण करा.',
    noActKey: "आतापर्यंत कोणतीही अक्टिव्हेशन किज् निर्माण केली नाही.",
    buttonAbv: "वरील बटण",
    numberOfActKey: "ॲक्टिव्हेशन किज् ची संख्या",
    membershipRole: "सदस्यता भूमिका",
    membershipPlan: "सभासद योजना",
    comments: "टिप्पणी",
    genKeys: "किज् निर्माण करा",
    keysNum: "किज् संख्या",
    phoneNumber: "फोन क्रमांक",
    keysStatus: "किज् सद्यस्थिती",
    ActivationKeysList: "अक्टिव्हेशन किज् ची सूची",
    back: "मागे",
    usingActKeys: "अक्टिव्हेशन किज् निर्माण करा वापरून",
    pleaseGenActKeyss: "कृपया अक्टिव्हेशन किज् निर्माण करा.",
    clearAllFilters: "सर्व छानन्या दूर करा.",
    salesManager: "विक्री व्यवस्थापक",
    clearAll: "सर्व साफ करा.",
    generatedBy: "याने निर्माण केले",
    numberOfKeys: "किज् ची संख्या",
    action: "कार्यवाही",
    viewAllUplFiles: "अपलोड केलेल्या सर्व फाइल्स दर्शवा",
    bulkUploadUsers: "ठोक-अपलोड वापरकर्ते",
    noActivationKeyFound: "कोणतीही अक्टिव्हेशन किज् आढळली नाही.",
    pleaseCreateAdminRole: "कृपया ॲडमिनची भूमिका निर्माण करा",
    btnCreateAdmin: "ॲडमिनची भूमिका निर्माण करा चा वापर करून",
    donwloadAsCsv: "सीएसव्ही स्वरूपात डाउनलोड करा.",
    donwloadAsPdf: "पीडीएफ स्वरूपात डाउनलोड करा.",
    assignSalesManager: "विक्री व्यवस्थापक प्रदान करा.",
    shareViaEmail: "ईमेल द्वारे सामाईक करा.",
    sendEmail: "ईमेल पाठवा",
    emailSend: "ईमेल यशस्विरीत्या पाठवला",
    donwload: "डाउनलोड करा",
    deleteFile: "फाईल काढून टाका",
    invalidFileData: "फाइलवरील सक्रियकरण की डेटा अवैध आहे",
    continue: "सुरू ठेवा",
    description: "वर्णन",
    selectWeek: "आठवडा निवडा",
    confirm: "निश्चित करा",
    selectMonth: "महिना निवडा",
    selectDateRange: "दिनांकाची विस्तारकक्षा निवडा",
    regionDistrict: "परगणा/जिल्हा",
    address: "पत्ता",
    familyTribe: "कूटुंबाची जमात",
    website: "वेबसाइट",
    deactivated: "निष्क्रिय केलेले",
    active: "सक्रिय",
    country: "देश",
    save: "जतन करा",
    stateIsReq: "राज्य आवश्यक आहे",
    cityIsReq: "शहर आवश्यक आहे",
    addressIsReq: "Address is required",
    membershipTypeReq: "Membership type is required",
    extendedReasonReq: "Extend reason is required",
    numberOfDaysReq: "Number of days is required",
    extendedMembershipValidity: "सदस्यतेची वाढीव वैधता",
    set: "SET",
    adminRole: "ॲडमिनच्या भूमिका",
    typeMsg: "Type your message here",
    farmer: "शेतकरी",
    commodity: "वस्तू",
    quantity: "प्रमाण",
    unit: "एकक",
    price: "किंमत",
    errors: {
      cannotBeBlank: "ही जागा रिक्त असू नये.",
      required: "हा रकाना भरणे आवश्यक आहे",
      somethingWentWrong:
        "काही तरी चूक झाली. थोड्या वेळाने पुन्हा प्रयत्न करा.",
    },
    loadingData: "सांख्यिके सादर करीत आहोत....",
    markAsRead: "वाचल्याचे चिन्हांकित करा",
    membership: {
      remainingDays: "उर्वरित दिवसांची संख्या",
      type: "सदस्यतेचा प्रकार",
      validity: "सदस्यतेची वैधता",
      validityLength: {
        custom: "स्वनिर्धारण",
        expired: "मुदत संपली",
        oneTo8Months: "1-8 महीने",
        lessThan1Month: "1 महिण्यापेक्षा कमी",
        moreThan1Month: "1 वर्षापेक्षा जास्त",
        sixTo12Months: "6-12 महिने",
      },
    },
    of: "चे",
    ok: "ठीक आहे",
    statusItems: {
      closed: "बंद",
      open: "सुरू",
    },
    orderByItems: {
      all: "सर्व",
      dateAscending: "चढत्या क्रमाने दिनांक",
      dateDescending: "उतरत्या क्रमाने दिनांक",
      dueDate: "नियत दिनांक",
      high: "उच्च",
      low: "निम्न",
      medium: "मध्यम",
    },
    orderBy: "या प्रमाणे मागणी",
    select: "निवडा",
    type: "प्रकार",
    uploadImageVideo: "चित्र/व्हिडीओज् अपलोड करा",
    user: "वापरकर्ते",
    userName: "वापरकर्त्याचे नाव",
    usersSelected: "निवडलेले वापरकर्ते",
    topics: "मथळे",
    date: "दिनांक",
    addNew: "नवीन प्रविष्ट करा.",
    exportAsCsv: "सीएसव्ही फाईल मिळवा",
    noData: "सांख्यिके मिळाली नाहीत.",
    login: {
      welcomeMsg: "सुस्वागतम! लॉग-इन करा.",
      info: "तुमचे ओळख-पुरावे प्रविष्ट करा.",
      forgot: "पासवर्ड विसरलात का?",
      btn: "लॉग-इन",
      unableToLogin: "लॉग-इन करता येत नाही!",
    },
    forgot: {
      info_l1:
        "कृपया तुमच्या खात्याशी निगडित असलेला ईमेल प्रविष्ट करा. पासवर्ड संबंधी तपशील तुमच्या ईमेलवर पाठवण्यात येतील.",
      info_l2:
        "कृपया तुमच्या खात्याशी संलग्न असलेला मोबाईल क्रमांक येथे प्रविष्ट करा. पासवर्डचे तपशील संबधीत मोबाईलवर पाठवण्यात येतील.",
      info_l3:
        "पासवर्डची पुन:रचना करण्यासाठी आवश्यक सूचना प्राप्त करण्यासाठी खालीलपैकी योग्य पर्याय निवडा.",
      forgotQ: "पासवर्ड विसरलात का?",
      loginNow: "आत्ताच लॉग-इन करा.",
      resetSucc: "तुमचा पासवर्ड यशस्वीरित्या बदलविण्यात आला आहे.",
      resetSucc_l2:
        "खात्यात लॉग-इन करण्यासाठी तुम्हाला नवीन पासवर्ड वापरता येईल.",
      entPsw: "नवीन पासवर्ड प्रविष्ट करा.",
      resetPsw: "पासवर्ड बदलवा.",
      resendOTP: "पुन्हा ओटीपी पाठवा.",
      enterCorrectOTP: "कृपया योग्य ओटीपी प्रविष्ट करा.",
      enterOTP: "तुमच्या ईमेल/मोबाईलवर प्राप्त ओटीपी येथे प्रविष्ट करा",
      backToLoginPage: "लॉग-इन पृष्ठावर परत जा.",
      recieveCodeFalse: "मला कोड प्राप्त झाला नाही.",
    },
    userslist: {
      createNewUser: "Create a New User",
      chooseCreateType: "Please choose one of the following options:",
      addNewUser: "नवीन वापरकर्ता प्रविष्ट करा",
      editUser: "वापरकर्ता संपादित करा.",
      addNewAdmin: "नवीन ॲडमिन वापरकर्ता",
      userLoading: "माहिती सादर करीत आहोत....कृपया प्रतीक्षा करा.",
      noUser: "वापरकर्ता उपलब्ध नाही.",
      extendVal: "वैधता वाढवा",
      extendReason: "विस्ताराचे कारण",
      extendReasonMsg: "सदस्यता वाढविण्याचे कारण नमुद करा",
      exportAsCSV: "सीएसव्ही फाईल मिळवा",
      membershipType: "सदस्यतेचा प्रकार",
      membershipValidity: "सदस्यतेची वैधता",
      regionState: "प्रांत/राज्य",
      cityTown: "शहर/गाव",
      clearAll: "सर्व साफ करा.",
      search: "शोधा",
    },
    addEdituser: {
      firstNameRequired: "नाव आवश्यक आहे.",
      firstNameOllyAlpha: "नावात केवळ अक्षरे असावीत.",
      firstNameLimit: "नाव 15 वर्णांपेक्षा कमी असावे.",
      lastNameRequired: "आडनाव आवश्यक आहे",
      lastNameOllyAlpha: "आडनाव केवळ अक्षरे असावीत.",
      lastNameLimit: "आडनाव 15 वर्णांपेक्षा कमी असावे.",
      emailReuired: "ईमेल आवश्यक आहे",
      emailInvalid: "ईमेल वैध स्वरुपात नाही.",
      mobileRequired: "मोबाईल क्रमांक आवश्यक आहे",
      invalidMobile: "मोबाईल क्रमांक वैध स्वरुपात नाही.",
      pswRequired: "पासवर्ड आवश्यक आहे",
      deptRequired: "विभाग आवश्यक आहे",
      roleRequired: "भूमिका आवश्यक आहे",
      countryRequired: "देशाचा कोड आवश्यक आहे",
      userUpdated: "वापरकर्ता अद्ययावत केला.",
      userNotUpdated: "वापरकर्ता अद्ययावत केला नाही.",
      activateAct: "खाते सक्रिय करा.",
      deactivateAct: "खाते निष्क्रिय करा.",
      userActivated: "वापरकर्त्यास सक्रिय करण्यात आले.",
      userDeactivated: "वापरकर्त्यास निष्क्रिय करण्यात आले.",
      deactivateUser: "वापरकर्त्यास निष्क्रिय करा.",
      deactivateMsg: "तुम्हाला वापरकर्त्याची स्थिती नक्की बदलवायची आहे का?",
      userAdded: "वापरकर्ता प्रविष्ट केला आहे.",
      userNotAdded: "वापरकर्ता प्रविष्ट केला नाही.",
      validityUpTo: "Validity Up To",
      facilityPicture: "Facility Picture",
      editAppUser: "ॲप वापरकर्ता संपादित करा.",
    },
    permissions: {
      savePermissions: "परवानग्या जतन करा.",
      moduleName: "घटकाचे नाव",
      view: "बघा",
      create: "निर्माण करा",
      update: "अद्ययावत करा.",
      delete: "काढून टाका.",
      permissionsUpdated: "सेटिंग्ज अद्ययावत नाही.",
      permissionsNotUpdated: "परवानग्या अद्ययावत नाहीत.",
      selectMembership: "सदस्यता निवडा.",
      noPermMsg:
        "कृपया 'सभासद प्रकार' च्या डॉप-डाउन मधील तुमच्या परवाणग्या बघून तुमचा सभासद प्रकार निवडा.",
      selectRoleMsg: "परवानग्या दर्शविण्यासाठी कृपया वरील भूमिका निवडा.",
    },
    logs: {
      time: "वेळ",
      username: "वापरकर्त्याचे नाव",
      role: "भूमिका",
      terminalID: "टर्मिनल आयडी",
      moduleAccessed: "प्रवेश मिळालेला घटक",
      typeOfAccess: "प्रवेशाचे प्रकार",
      activityLogDetails: "कार्य नोंदणीचा तपशील",
      userId: "वापरकर्त्याचा आयडी",
      lastLogin: "शेवटचे लॉग-इन",
      geoAccPoint: "प्रवेशाचा भौगोलिक बिंदू",
      ipAdd: "आयपी पत्ता",
      filesAccessed: "प्रवेश मिळालेल्या फाईल्स",
      funAccessed: "प्रवेश मिळालेले फंक्शन",
      webUrl: "वेब पृष्ठाचे यूआरएल",
      unsuccAtmp: "लॉग-इनचा अयशस्वी प्रयत्न",
      view: "बघा",
      membershipType: "सदस्यतेचा प्रकार",
    },
    profileSetting: {
      profileAuthSettings: "प्रोफाईल प्रमाणीकरणाची मांडणी",
      changeSettings: "मांडणीत बदल करा",
      loginLogoutSettings: "लॉग-इन/लॉग-ऑफची मांडणी ",
      autoLogout: "आपोआप लॉग-ऑफ",
      unsuccAtmp: "लॉग-इनचा अयशस्वी प्रयत्न",
      unsuccLoginLock: "अयशस्वी लॉग-इन लॉक-आऊट कालावधी",
      pswCrisetup: "पासवर्ड निकषांची रचना",
      pswLength: "पासवर्डची लांबी",
      noOfUniquePsw: "आवश्यक एकमेव पासवर्डस् ची संख्या",
      maxPswAge: "पासवर्डचा कमाल कालावधी",
      AccRangeOfchars: "स्वीकार्य वर्णांची व्याप्ती",
      upperCase: "अप्पर केस",
      lowerCase: "लोवर केस",
      numbers: "संख्या",
      specialChars: "विशिष्ट वर्ण",
      settingsUpdated: "सेटिंग्ज अद्ययावत आहे.",
      settingsNotUpdated: "सेटिंग्ज अद्ययावत नाही.",
    },
    dashboardSection: {
      modules: "घटक",
      allowances: "भत्ते",
      maxUserAllowed: "अनुमत कमाल वापरकर्ते",
      satelliteReportsAllowed: "अनुमत उपग्रह अहवाल",
      advanceReport: "अनुमत प्रगत अहवाल",
      subscriptionUpTo: "पर्यंत सदस्यताआहे",
      roleAllowed: "अनुमत भूमिका",
      moduleAllowed: "अनुमत घटक",
      registeredUsers: "नोदणीकृत वापरकर्ते",
      validMemberships: "वैध सदस्यता",
      activeUsers: "सक्रिय वापरकर्ते",
      deactivatedUsers: "निष्क्रिय केलेले वापरकर्ते",
      membershipValidity: "सभासद वैधता",
      lessThan1Month: "1 महिण्यापेक्षा कमी",
      months1to6: "1-6 महिने",
      months6to12: "6-12 महिने",
      moreThan1Year: "1 वर्षापेक्षा जास्त",
      cropOverview: "पिक आढावा",
      plantations: "मळे ",
      coffeeData: "कॉफी सांख्यिके",
      availableModules: "उपलब्ध घटक",
      roleList: "शेतकरी, खरेदी केंद्र, गोदाम",
      memberData: "सदस्य डेटा",
      userType: "वापरकर्ता प्रकार",
      registered: "नोंदणीकृत",
      offlineUsers: "ऑफलाइन वापरकर्ते",
      lessThanOneMonth: "< 1 महिना",
      cacaoData: "कॅकॅओ डेटा",
      dryCacao: "कॅकॅओ खरंडित",
      traceability: "ट्रेसेबिलिटी",
    },
    adminRoles: {
      adminRoles: "ॲडमिनच्या भूमिका",
      roleName: "भूमिकेचे नाव",
      description: "वर्णन",
      viewPermissions: "परवानग्या बघा",
      createAdminRole: "ॲडमिनची भूमिका निर्माण करा",
      enterDesHere: "तुमचे वर्णन येथे प्रविष्ट करा",
      deleteRole: "भूमिका  काढून टाका",
      deleteMsg: "तुम्हाला नक्की भूमिका  काढून टाकायची आहे काय?",
      roleReq: "भूमिकेचे नाव आवश्यक आहे",
      roleLimit: "भूमिकेचे नाव 15 वर्णांपेक्षा कमी असावे",
      desReq: "वर्णन आवश्यक आहे",
      desLimit: "वर्णन 40 किंवा त्यापेक्षा कमी वर्णांचे असावे",
      roleSuccess: "भूमिका यशस्विरीत्या निर्माण झाली",
      editAdminRole: "ॲडमिनची भूमिका संपादित करा.",
      roleUpdated: "भूमिका अद्ययावत केली.",
      noRole: "ॲडमिनच्या भूमिका आढळल्या नाहीत",
      noRoleMsg:
        "वरील 'ॲडमिनची भूमिका निर्माण करा' बटण वापरून ॲडमिनची भूमिका निर्माण करा.",
    },
    membershipplanSection: {
      defaultPlan: " डिफॉल्ट योजना",
      planType: "योजनेचा प्रकार",
      planDuration: "योजनेचा कालावधी",
      planFee: "योजना शुल्क",
      satelliteReport: "उपग्रह अहवाल",
      advanceReport: "प्रगत अहवाल",
      addMembership: "सदस्यता प्रविष्ट करा",
      addMembershipPlan: "सभासद योजना प्रविष्ट करा",
      editMembershipPlan: "सभासद योजना संपादित करा",
      accessSetelite: "उपग्रह अहवाल बघण्याची मुभा (5 अहवालांचा संच)",
      accessAdvanceReport: "प्रगत अहवाल बघण्याची मुभा",
      memPlanReq: "सदस्यता योजना आवश्यक आहे",
      memPlanReqLimit: "सदस्यता योजना 20 वर्णांपेक्षा कमी असावी",
      SatelliteReq: "उपग्रह अहवाल आवश्यक आहे",
      advancedReportReq: "प्रगत अहवाल आवश्यक आहे",
      durationReq: "सदस्यतेचा कालावधी आवश्यक आहे",
      feeReq: "सदस्यता शुल्क आवश्यक आहे",
      cantLesThenZero: "0 पेक्षा कमी असू नये",
      roleReq: "वापरकर्त्याची भूमिका आवश्यक आहे",
    },
    tickets: {
      actions: {
        create: "तिकीट तयार करा",
        delete: "तिकीट काढून टाका.",
        edit: "तिकीट संपादित करा.",
      },
      areaOfRequest: "विनंतीचे क्षेत्र",
      assignee: "मुखत्यार",
      deleteTicket: {
        confirmation: "तुम्हाला नक्की तिकीट काढून टाकायचे आहे का?",
      },
      dueDate: "नियत दिनांक",
      filters: {
        ticketFor: "यासाठी तिकीट",
      },
      form: {
        ticketType: {
          admin: "दिमीत्रा ॲडमिनसाठी तिकीट निर्माण करा",
          user: "ॲप वापरकर्त्यासाठी तिकीट निर्माण करा",
        },
      },
      markAsRead: "वाचल्याचे चिन्हांकित करा",
      messages: {
        created: {
          success: "तिकीट यशस्विरीत्या निर्माण झाले.",
        },
        deleted: {
          success: "तिकीट यशस्विरीत्या काढून टाकाले.",
        },
      },
      noData: "तिकीट आढळले नाही.",
      noDataHelpText: `तुम्हाला कोणतेही तिकीट (0) प्रदान करण्यात आलेले नाही. सुरवात करण्यासाठी स्किनच्या सर्वात वरच्या भागातील 'तिकीट निर्माण करा' बटणावर (1) क्लिक करा.`,
      pickerInMenu: "मेनूतील चयनकर्ता",
      priority: {
        high: "उच्च",
        label: "प्राधान्य",
      },
      reply: "प्रतिसाद",
      requestedDateTime: "विचारलेली सांख्यिके व वेळ",
      requestorDetails: "विचारलेली वर्णने",
      requestorEmail: "विनंतीकर्त्याची ईमेल",
      subject: "विषय",
      ticketsForItems: {
        all: "सर्व",
        dimitraAdmin: "दिमीत्रा ॲडमिन",
        multipleUsers: "अनेक वापरकर्ते",
        singleUser: "एकल वापरकर्ता",
      },
      title: "तिकीटस्",
    },
    roleRequest: {
      roleRequest: "भूमिकेसाठी विनंती",
      userRole: "वापरकर्त्याची भूमिका",
      approve: "मान्य करा",
      reject: "अमान्य करा",
      username: "वापरकर्त्याचे नाव",
      email: "ईमेल",
      phone: "फोन",
      roleAssigned: "सोपवलेली भूमिका",
      roleRequested: "भूमिकेसाठी विनंती",
      requestedDate: "विनंतीचा दिनांक",
      updateRoleRequest: "भूमिकेची विनंती अद्ययावत करा.",
      message: "संदेश",
      update: "अद्ययावत करा.",
    },
    faqSection: {
      createFaq: "एफएक्यूज्/नेहमीची प्रश्नोत्तरे तयार करा.",
      createTopic: "मथळा तयार करा",
      selectTopic: "विषय निवडा",
      faqQuestion: "एफएक्यू प्रश्न",
      faqAnswer: "एफएक्यू उत्तरे",
      uploadImgVid: "चित्र/व्हिडीओ अपलोड करा",
      disInFaq: "एफएक्यू विभागात दर्शवा",
      editFaq: "एफएक्यू संपादित करा",
      topicName: "विषयाचे नाव",
      parentTopic: "मूळ विषय",
      editTopic: "विषय संपादित करा",
      createSection: "Please create section first",
      createTopicFirst: "Please create topic first",
      questionReq: "FAQ Question is required",
      answerReq: "FAQ Answer is required",
    },
    reports: {
      farmerName: "शेतकऱ्याचे नाव",
      farmerProdChart: "शेतकऱ्याच्या उत्पादनाचा तक्ता",
      production: "उत्पादन",
      byProduction: "उत्पादनानुसार",
      byName: "नावानुसार",
      descending: "उतरताक्रम",
      ascending: "चढताक्रम",
      buyingStationProdChart: "खरेदी केंद्र उत्पादन तक्ता",
      buyingStation: "खरेदी केंद्र",
      buyingStationName: "खरेदी केंद्राचे नाव",
      dryMilling: "कोरडे दळणे",
      dryMillingName: "कोरड्या दळण्याचे नाव",
      dryMillingProdChart: "कोरड्या दळण्याचा उत्पादन तक्ता",
      view: "बघा",
      date: "दिनांक",
    },
    traceability: {
      traceability: "ट्रेसेबिलिटी",
      coffeeTraceabilityMngmnt: "कॉफी ट्रेसेबिलिटी व्यवस्थापन",
      traceabilityPage: "ट्रेसेबिलिटी पृष्ठ",
      labelDesigner: "लेबल डिझायनर",
      additionalInformation: "अतिरिक्त माहिती",
      info1:
        "आपल्या उत्पादाच्या अतिरिक्त लोगोंबद्दल माहिती पुरवा. हा माहिती कॉफी ट्रेसेबिलिटी पृष्ठावर सार्वजनिक असेल.",
      addSlogan: "स्लोगन जोडा",
      additionalLogos: "अतिरिक्त लोगोंस",
      title: "शीर्षक",
      description: "वर्णन",
      mapLink: "नकाशा दुवा",
      websiteLink: "वेबसाइट दुवा",
      addMedia: "मिडिया जोडा",
      uploadImageVideo: "चित्र/व्हिडिओ अपलोड करा",
      origin: "मुख्य ठिकाण",
      info2:
        "आपल्या उत्पादाच्या मूळ देशाबद्दल माहिती पुरवा. हा माहिती कॉफी ट्रेसेबिलिटी पृष्ठावर सार्वजनिक असेल.",
      countryImage: "देश चित्र",
      institutionalInfo: "संस्थागत माहिती",
      info3:
        "आपल्या कंपनी/सहकार्याबद्दल माहिती पुरवा, उपभोक्त्यांना आपल्याकडून केलेल्या संबंधित कामांच्या बद्दल सांगा. हा माहिती कॉफी ट्रेसेबिलिटी पृष्ठावर सार्वजनिक असेल.",
      cooperativeLogo: "सहकारी लोगो",
      traceabilityIntro: "ट्रेसेबिलिटी परिचय",
      info4:
        "हा विभाग उपभोक्त्याला कॉफीच्या संपूर्ण उत्पादन आणि प्रक्रियांच्या इतिहासाची प्रवेश देणार आहे. आपल्या कंपनी/सहकार्याच्या आणि जगाच्या ट्रेसेबिलिटीच्या महत्त्वाचे वर्णन करा.",
      addLabel: "लेबल जोडा",
      chooseTitle: "शीर्षक निवडा",
      chooseLabelDesign: "लेबल डिझायन टेम्प्लेट निवडा",
      uploadYourLogo: "आपल्या लोगो अपलोड करा",
      info5:
        "मार्गदर्शन: चित्राचा आकार किमान 1000 x 1000 पिक्सेल चौरस असणे आवश्यक आहे. आपण फारक स्पष्ट PNG निवडू शकता ज्यासाठी पृष्ठभूमीच्या रंगांसह समवाद बद्दल आहे.",
      chooseTemplateColors: "टेम्प्लेट रंग निवडा",
      backgroundColor: "पृष्ठभूमि रंग",
      foregroundColor: "मुख्य रंग",
      labelStatus: "लेबल स्थिती",
      inactive: "निष्क्रिय",
      download: "डाउनलोड करा",
      enterLabelTitle: "लेबल शीर्षक प्रविष्ट करा",
    },
    cacaoTraceability: {
      traceability: "ट्रेसेबिलिटी",
      cacaoTraceabilityMngmnt: "कॅकॉ ट्रेसेबिलिटी व्यवस्थापन",
      traceabilityPage: "ट्रेसेबिलिटी पृष्ठ",
      labelDesigner: "लेबल डिझायनर",
      additionalInformation: "अतिरिक्त माहिती",
      info1:
        "आपल्या उत्पादाच्या अतिरिक्त लोगोंबद्दल माहिती पुरवा. हा माहिती कॅकॉ ट्रेसेबिलिटी पृष्ठावर सार्वजनिक असेल.",
      addSlogan: "स्लोगन जोडा",
      additionalLogos: "अतिरिक्त लोगोंस",
      title: "शीर्षक",
      description: "वर्णन",
      mapLink: "नकाशा दुवा",
      websiteLink: "वेबसाइट दुवा",
      addMedia: "मिडिया जोडा",
      uploadImageVideo: "चित्र/व्हिडिओ अपलोड करा",
      origin: "मुख्य ठिकाण",
      info2:
        "आपल्या उत्पादाच्या मूळ देशाबद्दल माहिती पुरवा. हा माहिती कॅकॉ ट्रेसेबिलिटी पृष्ठावर सार्वजनिक असेल.",
      countryImage: "देश चित्र",
      institutionalInfo: "संस्थागत माहिती",
      info3:
        "आपल्या कंपनी/सहकार्याबद्दल माहिती पुरवा, उपभोक्त्यांना आपल्याकडून केलेल्या संबंधित कामांच्या बद्दल सांगा. हा माहिती कॅकॉ ट्रेसेबिलिटी पृष्ठावर सार्वजनिक असेल.",
      cooperativeLogo: "सहकारी लोगो",
      traceabilityIntro: "ट्रेसेबिलिटी परिचय",
      info4:
        "हा विभाग उपभोक्त्याला कॉफीच्या संपूर्ण उत्पादन आणि प्रक्रियांच्या इतिहासाची प्रवेश देणार आहे. आपल्या कंपनी/सहकार्याच्या आणि जगाच्या ट्रेसेबिलिटीच्या महत्त्वाचे वर्णन करा.",
      addLabel: "लेबल जोडा",
      chooseTitle: "शीर्षक निवडा",
      chooseLabelDesign: "लेबल डिझायन टेम्प्लेट निवडा",
      uploadYourLogo: "आपल्या लोगो अपलोड करा",
      info5:
        "मार्गदर्शन: चित्राचा आकार किमान 1000 x 1000 पिक्सेल चौरस असणे आवश्यक आहे. आपण फारक स्पष्ट PNG निवडू शकता ज्यासाठी पृष्ठभूमीच्या रंगांसह समवाद बद्दल आहे.",
      chooseTemplateColors: "टेम्प्लेट रंग निवडा",
      backgroundColor: "पृष्ठभूमि रंग",
      foregroundColor: "मुख्य रंग",
      labelStatus: "लेबल स्थिती",
      inactive: "निष्क्रिय",
      download: "डाउनलोड करा",
      enterLabelTitle: "लेबल शीर्षक प्रविष्ट करा",
    },
    setting: {
        profileAuthSetting: "प्रोफाईल प्रमाणीकरणाच्या सेटिंग्ज",
        logInOutSetting: "लॉग-इन/लॉग-ऑफच्या सेटिंग्ज",
        autoLogout: "आपोआप लॉग-ऑफ",
        unsuccessfulLoginAttempt: "लॉग-इनचा अयशस्वी प्रयत्न",
        unsuccessfulLoginLockPeriod: "लॉग-इनचा अयशस्वी प्रयत्न",
        passCriteriaSetup: "पासवर्ड निकषांची रचना",
        passLength: "पासवर्डची लांबी",
        noUniquePassRequired: "आवश्यक एकमेव पासवर्डस् ची संख्या",
        maxPassAge: "पासवर्डचा कमाल कालावधी",
        acceptableRangeOfChars: "स्वीकार्य वर्णांची व्याप्ती",
        upperCase: "अप्पर केस",
        lowerCase: "लोअर केस",
        numbers: "संख्या",
        specialChars: "विशिष्ट वर्ण",
        uniqueSymbols: "विशिष्ट वर्ण",
        loadingData: "सांख्यिके सादर करीत आहोत....",
        currency: "चलन",
        codeActivationTime: "कोड सक्रिय करण्याची वेळ",
        changeGlobalSetting: "समग्र सेटिंग्ज बदलवा",
        globalSetting: "समग्र सेटिंग्ज",
        generalSetting: "सर्वसाधारण सेटिंग्ज",
        hour: "तास",
        days: "दिवस",
        minutes: "मिनीट्स",
        perDay: "प्रति दिवस",
        perHour: "प्रति तास",
        customised: "स्वनिर्धारित",

        smallFarm: "लहान शेत",
        inclusive: "समावेशक",
        from: "पासून",
        to: "पर्यंत",
        mediumFarm: "मध्यम शेत",
        largeFarm: "मोठे शेत",
        requiredMessage: "हे क्षेत्र आवश्यक आहे",
        nonNegativeMessage: "हे क्षेत्र गैर-नकारात्मक असावे",
        fieldToGreaterThanFrom: "हे क्षेत्र 'पासून' क्षेत्रापेक्षा मोठे असावे",
        fieldToGreaterThanFromMedium: "हे क्षेत्र लहान शेताच्या 'पर्यंत' क्षेत्रापेक्षा मोठे असावे",
        fieldToGreaterThanMediumTo: "हे क्षेत्र मध्यम शेताच्या 'पर्यंत' क्षेत्रापेक्षा मोठे असावे",
    },
    coffeeData: {
      windBreaker: "वात रोधक झाडे",
      horticultureInfo: "उद्यानकृषी झाडे",
      shadeTree: "छायावृक्ष",
      coffeeVariety: "कॉफीचे वाण",
      coffeeSpecies: "कॉफीची प्रजाती",
      updateWindBreaker: "वात रोधक झाडांचा प्रकार अद्ययावत करा",
      addWindBreaker: "नवीन वातप्रतिरोधक झाडाचा प्रकार प्रविष्ट करा.",
      updateHorticultureInfo: "उद्यानकृषी झाडांचा प्रकार अद्ययावत करा",
      addHorticultureInfo: "नवीन उद्यानकृषी झाडांची प्रकार प्रविष्ट करा.",
      updateShadeTree: "छायावृक्षाचा प्रकार अद्ययावत करा",
      addShadeTree: "Add New shadeTree Tree Type",
      updateCoffeeVariety: "कॉफी वाणाचा प्रकार अद्ययावत करा",
      addCoffeeVariety: "कॉफी वाणाचा प्रकार प्रविष्ट करा",
      deleteVarietyTitle: "वाण काढून टाका",
      deleteVarietyMessage: "तुम्हाला हे वाण नक्की काढून टाकायचे आहे का?",
      updateCoffeeSpecie: "कॉफीची प्रजाती अद्ययावत करा.",
      deleteSpecieTitle: "कॉफीची प्रजाती काढून टाका.",
      deleteSpecieMessage: "तुम्हाला ही प्रजाती काढून टाकायची आहे का?",
      addCoffeeSpecie: "नवीन कॉफी प्रजाती प्रविष्ट करा.",
      variety: "वाण",
      selectVariety: "प्रजाती निवडा",
      deleteCoffeeRecord: "तुम्हाला नोंद नक्की काढून टाकायची आहे का?",
      deleteCoffeeData: "कॉफीची सांखिके काढून टाका.",
      topicRequired: "विषयाचे नाव आवश्यक आहे",
      coffeeAddSuccess: "कॉफीची प्रजाती यशस्विरीत्या प्रविष्ट केली",
      treeTypeSuccess: "झाडाचा प्रकार यशस्विरीत्या प्रविष्ट केला",
      treeTypeUpdateSuccess: "झाडाचा प्रकार यशस्विरीत्या अद्ययावत केला",
      coffeeVarietySuccess: "कॉफीचे वाण यशस्विरीत्या प्रविष्ट केले",
      coffeeSpecieSuccess: "कॉफीची प्रजाती यशस्विरीत्या अद्ययावत केली",
      nameRequired: "नाव आवश्यक आहे",
      notFound: "ॲडमिनची कॉफी सांख्यिके आढळली नाहीत",
    },
    plantation: {
      farmerName: "शेतकऱ्याचे नाव",
      phoneNumber: "फोन क्रमांक",
      plantationName: "मळ्याचे नाव",
      farm: "शेत",
      location: "स्थान",
      updatePlantationStatus: "मळ्याची सद्यस्थिती अद्ययावत करा.",
      update: "अद्ययावत करा.",
    },
    surveyBuilder: {
      addNewSurvey: "Add New Survey",
      surveyTitle: "Survey Title",
      surveyName: "Survey Name",
      surveyDescription: "Survey Description",
      describeSurvey: "Describe the Survey",
      enableScheduling: "Enable Scheduling",
      selectedDate: "Selected Date",
      multiStepSurvey: "Multi-Step Survey",
      multiStepSurveyDetails:
        "Based on the number of questions in a step, all questions in the survey will be grouped and displayed in steps.",
      multiStep: "Multi Step",
      noQuestionEachStep: "Number of questions in each step",
      surveyStatus: "Survey Status",
      surveyStatusDetails:
        "Survey can be enabled only after adding questions. Enabling a survey will allow farmers to start submissions.",
      selectUsers: "Select Users",
      selectUsersDetails:
        "If select user is disabled then the survey will be available to all the users. If you Enable selected users you can select multiple users in the next step.",
      linkWithFarms: "Link With Farms",
      linkWithFarmsDetails:
        "If enabled the survey will be linked with individual farms. If a Farmer has multiple farms then each farm will have its own survey.",
      enabled: "Enabled",
      disabled: "Disabled",
      cancel: "Cancel",
      next: "Next",
      surveySettings: "Survey Settings",

      selectSurveyUsers: "सर्वेक्षण सदस्य निवडा",
      selectToProceed: "कृपया सदस्य निवडा प्राधिकृत करण्यासाठी",
      searchUsers: "सदस्य शोधा",
      usersSelected: "सदस्य निवडले आहे",
      conditional: "परिस्थितिक",
      autoConditional: "स्वयंचलित परिस्थितिक",
      userName: "वापरकर्त्याचे नाव",
      email: "ईमेल",
      membershipType: "सदस्यता प्रकार",
      membershipValidity: "सदस्यता वैधता",
      membershipRemainingDays: "शिल्लक असलेल्या दिवसाची संख्या",
      membershipRole: "सदस्य भूमिका",
      accountProgress: "खातीची प्रगती",
      status: "स्थिती",
      active: "सक्रिय",
      deactivated: "निष्क्रिय",
      continue: "सुरू ठेवा",
      questions: "प्रश्न",
      responses: "प्रतिसाद",
      deleteSurvey: "सर्वेक्षण हटवा",
      editSurvey: "सर्वेक्षण संपादित करा",
      type: "प्रकार",
      compulsory: "अनिवार्य",
      createSurvey: "सर्वेक्षण तयार करा",
      surveyBuilder: "सर्वेक्षण निर्माता",
      surveyList: "सर्वेक्षण यादी",
      farm: "शेत",
      responseDate: "प्रतिसाद दिनांक",
      viewSurvey: "सर्वेक्षण पहा",
      question: "प्रश्न",
      settings: "सेटिंग्ज",
      addQuestion: "प्रश्न जोडा",
      surveysSubmitted: "सर्वेक्षण सादर केलेले",
      surveyDetail: "सर्वेक्षण तपशील",
      conditionStatus: "परिस्थिती स्थिती",
      conditionStatusDesc:
        "परिस्थितियां सोडल्यास वापरकर्त्यांना स्वयंचलितपणे सर्वेक्षणासाठी पात्र होईल.",

      endSurvey: "सर्वेक्षण समाप्त करा",
      publishSurvey: "सर्वेक्षण प्रकाशित करा",
      copy: "कॉपी करा",
      view: "पहा",
      startDate: "सुरूवातीची तारीख",
      endDate: "समाप्तीची तारीख",
      chooseDate: "तारीख निवडा",
      select: "निवडा",
      addSurveyQuestion: "सर्वेक्षण प्रश्न जोडा",
      editSurveyQuestion: "सर्वेक्षण प्रश्न संपादित करा",
      questionScore: "प्रश्न स्कोअर",
      mandatory: "अनिवार्य",
      yes: "होय",
      no: "नाही",
      options: "पर्याय",
      typeHere: "येथे टाइप करा",
      add: "जोडा",
      optionsHint:
        "कृपया उत्तर टाइप करण्यासाठी Enter दाबा किंवा जोड्याच्या वर क्लिक करा",
      surveyProgress: "सर्वेक्षण प्रगतीत",
      allResponses: "सर्व प्रतिसाद संक्षेप",
      responseQuestion: "प्रश्नाने प्रतिसाद",
      dateSubmitted: "प्रस्तुत तारीख",
      answer: "उत्तर",
      totalScore: "एकूण स्कोअर",
      score: "स्कोअर",
      singleSelection: "एकल निवड",
      multipleSelection: "अनेक निवड",
      if: "जर",
      then: "तर",
      noResponse: "कोणत्याची प्रतिसाद नाही",
      noSurveyFound: "सर्वेक्षण सापडले नाहीत",
      createNewSurvey:
        'कृपया "सर्वेक्षण तयार करा" असा बटण वापरून सर्वेक्षण तयार करा',
      cannotPublish: "एक अक्षम सर्वेक्षण प्रकाशित करू शकत नाही!",
      deleteSurveyWarn:
        "सर्वेक्षण हटवू इच्छिता का? जर तुम्ही हटवलं तर सर्वेक्षणाच्या सर्व प्रश्न आणि प्रस्तुतकरण पर्मनेंटपणे हटवले जाईल.",
      noQuestionFound: "कोणत्याच्या प्रश्नांनी प्रतिसाद सापडला नाही",
      createQuestion: 'कृपया "प्रश्न जोडा" असा बटण वापरून पहिल्या प्रश्न जोडा',
      deleteQuestion: "कोणत्याच्या प्रश्नाचे हटवू इच्छिता का?",
      applyChanges: "तुम्हाला ही बदल अप्लाय कसे करायचं आहे?",
      editFutureSurveys: "भविष्यातील सर्वेक्षण संपादित करा",
      editLiveSurveyOnly: "केवळ लाइव सर्वेक्षण संपादित करा",
      surveyIsLive:
        "कृपया नोंदवा की सर्वेक्षण सध्या लाइव आहे, आणि आता प्रश्न संपादित करण्याची क्रिया आग्रहायक प्रस्तुतकरणांकितांकित करू शकतो. कोणत्याही अडचणी टाळण्यासाठी, तुम्ही प्रश्नांच्या बदल करण्यासाठी सर्वेक्षणाची एक प्रत तयार करून बदल करण्याचा विचार करू शकता.",
      clickToCopy: "सर्वेक्षण कॉपी तयार करण्यासाठी येथे क्लिक करा",
      applyChangesNow: "आत्ताच बदल लागू करा",
      copySurvey: "सर्वेक्षण कॉपी करा",
      changeCopySurveyName:
        "तुम्हाला कॉपी केलेल्या सर्वेक्षणाचं नाव बदलू शकता.",
    },
    memberDataSection: {
      coffeeType: "कॉफीचा प्रकार",
      buyingStationDetails: "खरेदी केंद्र तपशील",
      buyingStationUsers: "खरेदी केंद्र वापरकर्ते",
      activityLog: "क्रियाकलाप लॉग",
    },
    cropsReport: "फसळ अहवाल",
    today: "आज",
    week: "आठवडा",
    month: "महिना",
    year: "वर्ष",
    all: "सर्व",
    cropsStatistics: "फसळ सांख्यिकी",
    crops: "फसळे",
    acres: "एकडे",
    totalPlantedArea: "एकदार क्षेत्र",
    farmersChart: "शेतकरी चार्ट",
    cropsName: "फसळाचं नाव",
    farmers: "शेतकरी",
    farms: "शेते",
    planted: "रोपणे",
    plantedArea: "रोपलेला क्षेत्र",
    harvested: "काढले",
    yieldAcre: "वाढ / एकडे",
    selectCrop: "फसळ निवडा",
    listByYield: "वाढानुसार यादी",
    listByPlantedArea: "रोपलेल्या क्षेत्रानुसार यादी",
    equipmentReport: "उपकरण अहवाल",
    equipmentChart: "उपकरण चार्ट",
    selectFarmer: "शेतकरी निवडा",
    equipmentName: "उपकरणाचं नाव",
    region: "प्रदेश",
    counts: "गणना",
    large: "मोठे",
    medium: "मध्यम",
    small: "लहान",
    listByFarmer: "शेतकरीनुसार यादी",
    rowsPerPage: "प्रति पृष्ठ पंक्ती",
    farmersReport: "शेतकरी अहवाल",
    farmersStatistics: "शेतकरी सांख्यिकी",
    averageFarmerLand: "औसत शेतकरीचं भूमि",
    largeFarmers: "मोठे शेतकरी",
    mediumFarmers: "मध्यम शेतकरी",
    smallFarmers: "लहान शेतकरी",
    listByLand: "भूमीनुसार यादी",
    listByFarm: "शेतीनुसार यादी",
    AvgLandAcre: "औसत भूमी / एकड",
    listbyCrop: "फसळानुसार यादी",
    listbyZone: "क्षेत्रानुसार यादी",
    farmName: "शेताचं नाव",
    zones: "क्षेत्रे",
    area: "क्षेत्र",
    goalsAchievedReport: "लक्ष्य साधले अहवाल",
    listByCrops: "फसळानुसार यादी",
    goalsAchievedChart: "लक्ष्य साधल्याचा चार्ट",
    goalsAchieved: "लक्ष्य साधले",
    goalsFailed: "लक्ष्य अयशस्वी",
    successRate: "यशस्वी दर",
    achieved: "साधले",
    equipment: "उपकरणे",
    pests: "किडके",
    regions: "प्रदेश",
    filterByCrops: "फसळानुसार फिल्टर करा",
    searchCrops: "फसळे शोधा",
    batchCode: "बॅच कोड",
    batchRating: "बॅच रेटिंग",
    MakeASelection: "निवड करा",
    typeTotalCoffeeQuantity: "कुल कॉफी मात्रा प्रकार करा",
    typeHumidity: "नमी प्रकार करा",
    valueInPercent: "प्रतिशतात्मक मूल्य",
    purchaseOrderRequired: "खरेदीचा ऑर्डर आवश्यक आहे",
    totalCoffeeCherryRequired: "कुल कॉफी चेरी आवश्यक आहे",
    processTypeRequired: "प्रक्रिया प्रकार आवश्यक आहे",
    stationInfo: "स्थान माहिती",
    purchaseOrders: "खरेदीचे ऑर्डर",
    processingBatch: "प्रक्रिया बॅच",
    processedCoffeeOutRequired: "प्रक्रियित कॉफी आउट आवश्यक आहे",
    lotNo: "लॉट नंबर",
    addNewS: "नविन जोडा",
    viewAll: "सर्व पहा",
    parchmentOut: "पारचमेंट आउट",
    processingDone: "प्रक्रिया संपली",
    farmerLotID: "शेतकरी आणि लॉट आयडी",
    weight: "वजन",
    plantationSettings: "बागवानी सेटिंग्स",
    PlantationsEachFarmerCanCreate:
      "प्रत्येक शेतकरी किती बागवानी तयार करू शकतो",
    manageAdditionalPlantationRequests: "अतिरिक्त बागवानी विनंती व्यवस्थित करा",
    autoApprove: "स्वयंमंजूर",
    adminApprovalRequired: "प्रशासकाच्या मंजूरीची आवश्यकता आहे",
    close: "बंद करा",
    new_user: "नवीन वापरकर्ता",
    KGAcre: "किलोग्रॅम/एकड",
  },
  oma: {
    //land suitability
    landSuitibility: "भूमि उपयुक्तता",
    landSuitibilityReport: "भूमि अनुपयुक्तता अहवाल",
    generateNewReport: "नवीन अहवाल तयार करा",
    operatorName: "ऑपरेटरचे नाव",
    issueDate: "मुद्दा तारीख",
    chooseYourLocation: "आपले स्थान निवडा",
    getLandEvaluation: "जमिनचे मूल्यांकन मिळवा",
    downloadPdfReport: "पीडीएफ अहवाल डाउनलोड करा",
    pleaseEnterCoordinateText:
      "कृपया फार्मच्या स्थानाचे अक्षांश (देशांतर आणि अक्षांश) प्रविष्ट करा आणि त्याचे गुणवत्ता पाहण्यासाठी.",
    noRecordAvailable: "कोणतेही निकाल उपलब्ध नाहीत.",
    overallScoreForLand: "जमीनसाठी संपूर्ण गुण",
    landEvaluation: "जमिनचे मूल्यांकन",
    unsuitable: "अयोग्य",
    marginally: "संविशेष",
    suitable: "योग्य",
    moderately: "मध्यम",
    highly: "उत्तम",
    back: "परत",
    search: "शोध",
    showResults: "निकाल दाखवा",

    //weather analysis
    weatherAnalysisReport: "हवामान विश्लेषण अहवाल",
    weatherAnalysis: "हवामान विश्लेषण",
    getWeatherAnalysis: "हवामान विश्लेषण मिळवा",
    weatherReport: "हवामान अहवाल",
    filterByDate: "तारीख नुसार फिल्टर करा",
    insertCoordinateText:
      "फार्म (किंवा झाड) ठिकाणाचे आक्षांश (किंवा अक्षांश) वर्तवा किंवा खालील नकाशाचा वापर करा आणि फार्म (किंवा झाड) ठिकाणाचे सूचन प्रदान करा.",
    addTreeGeolocation: "झाडाचे स्थान जोडा",
    editTreeGeolocation: "झाडाचे स्थान संपादित करा",
    plantationDate: "बागाची तारीख",
    notes: "टिप्पण्या",
    uploadTreeImages: "झाडाच्या छायाचित्रे अपलोड करा",

    valueAtTheCoordinatesOfInterest:
      "म्हणजे सर्वेक्षण करण्याच्या स्थळावरील मूल्य",
    "Slope (%)": "ढाल (%)",
    "Soil texture (USDA class)": "मातीचा अंश (USDA वर्ग)",
    "Coarse fragments (vol%)": "कोर्स फ्रॅगमेंट्स (vol%)",
    Land: "जमीन",
    "Artificial surfaces (type)": "कृत्रिम पृष्ठ (प्रकार)",
    "Proximity to Type 1 and 2 Roads (meters)":
      "प्रकार 1 आणि 2 रस्त्यांपासूनच्या आसपास (मीटर)",
    "Soil Chemical Properties": "मातीच्या रासायनिक गुण",
    "Soil Physical Properties": "मातीच्या भौतिक गुण",
    "Soil organic carbon (%)": "मातीचा सेंद्रिय कार्बन (%)",
    "Soil pH": "मातीचा pH",
    "Soil salinity (ECe))": "मातीची उपास्थिती (ECe)",
    "Mean annual temperature (°C)": "वार्षिक सरासरी तापमान (°C)",
    Weather: "आग्रह",
    "Mean minimum temperature of coldest month (°C)":
      "कमी ठंडी महिन्याचा सरासरी किमान तापमान (°C)",
    "Mean annual precipitation (mm)": "वार्षिक सरासरी पावसाची प्रमाण (mm)",
  },
  dueDiligence: {
    question: "प्रश्न",
    answer: "उत्तर",
    riskAssessment: "जोखीम मूल्यांकन",
  },
  deforestation: {
    riskLevel: "जोखीम",
    eudrComplianceStatus: "EUDR अनुपालन स्थिती",
    deforestationComplianceReport: "वनीकरण अनुपालन अहवाल",
    noDeforestationComplianceReport: "कोणताही वनीकरण अनुपालन अहवाल सापडला नाही",
    loadingDeforestationComplianceReport: "वनीकरण अनुपालन अहवाल लोड करत आहे",
    farmName: "शेतीचे नाव",
    farmRegistrationId: "शेती नोंदणी आयडी",
    farmerName: "शेतकऱ्याचे नाव",
    farmerRegistrationId: "शेतकरी नोंदणी आयडी",
    uniqueFarmerId: "अद्वितीय शेतकरी आयडी",
    uniqueFarmId: "अद्वितीय शेती आयडी",
    farmLocation: "शेतीचे स्थान",
    area: "क्षेत्र",
    farmAddress: "शेतीचा पत्ता",
    dateOfRequest: "विनंतीची तारीख",
    status: "स्थिती",
    settings: "सेटिंग्ज",

    farmLatitude: "शेती अक्षांश",
    farmLongitude: "शेती रेखांश",
    shareQRCode: "क्यूआर कोड सामायिक करा",
    copy: "कॉपी करा",

    allCountries: "सर्व देश",
    allRegions: "सर्व प्रदेश",
    allFarms: "सर्व शेत",
    viewCertificate: "प्रमाणपत्र पहा",

    assignmentIssued: "कार्य जारी केले",

    complianceCertification: "अनुपालन प्रमाणपत्र",
    noComplianceCertification: "कोणतेही अनुपालन प्रमाणपत्र आढळले नाही",
    loadingComplianceCertification: "अनुपालन प्रमाणपत्र लोड करत आहे",

    eudrForestAssessment: "EUDR वन मूल्यांकन",
    assessmentReport: "मूल्यांकन अहवाल",
    downloadPDF: "PDF डाउनलोड करा",
    back: "मागे",
    farmDetails: "शेती तपशील",

    dimitraFarmId: "दिमित्रा शेती आयडी",
    dimitraFermerId: "दिमित्रा शेतकरी आयडी",

    totalGeofenceAreaHA: "एकूण भू-फेन्स क्षेत्र (हेक्टेयर)",
    forestLossHA: "वन नुकसान (हेक्टेयर)",
    forestGainHA: "वन वाढ (हेक्टेयर)",
    forestUnchangedHA: "वन अपरिवर्तित (हेक्टेयर)",
    shareCertificate: "प्रमाणपत्र सामायिक करा",
    forestUnchanged: "वन अपरिवर्तित",
    forestLoss: "वन नुकसान",
    forestGain: "वन वाढ",
    totalGeofenceArea: "एकूण भू-फेन्स क्षेत्र",
    print: "प्रिंट करा",
    deforestationProbability: "वनीकरणाची शक्यता",
    colorCode: "रंग कोड",
    geofenceArea: "भू-फेन्स क्षेत्र",
    percentageOfGeofenceArea: "भू-फेन्स क्षेत्राचे टक्केवारी",
    view: "पहा",
    customization: "स्वयंनिर्मिती",
    recordsPerpage: "प्रति पृष्ठ रेकॉर्ड",
    restoreDefault: "डीफॉल्ट पुनर्स्थापित करा",
    apply: "लागू करा",
    forestAssessmentHelp:
      "जर या अहवालाबद्दल आपल्याला काही प्रश्न असतील किंवा त्यास समजण्यास मदत हवी असेल तर कृपया हेल्प डेस्कद्वारे आमच्याशी संपर्क साधा.",
    overallDeforestationProbability: "एकूण वनीकरणाची शक्यता",
    zeroOrNegligible: "शून्य/नगण्य",
    high: "उच्च",
    allStatus: "सर्व स्थिती",
    low: "निम्न",
    veryHigh: "खूप उच्च",
    medium: "मध्यम",
    veryLow: "खूप निम्न",
    assessmentIssued: "मूल्यांकन जारी केले",
    certificateIssued: "प्रमाणपत्र जारी केले",
    assessmentNo: "मूल्यांकन क्र.",
    blockchainCertificateDesc:
      "प्रमाणपत्राच्या स्वीकृतीनंतर ब्लॉकचेन प्रमाणपत्र मान्यता हॅश उपलब्ध होईल",
    blockchainValidation: "ब्लॉकचेन प्रमाणपत्र मान्यता",
    openBlockchainPage: "ब्लॉकचेन पृष्ठ उघडा",
    clickLinkDesc: "ब्लॉकचेनवर प्रमाणपत्र वैध करण्यासाठी वरील लिंकवर क्लिक करा",
    tooltip: {
      dimitraFarmId:
        "दिमित्रा प्रणालीमध्ये विशिष्ट शेताशी संबंधित अद्वितीय ओळखकर्ता.",
      farmName: "शेतीचे निर्दिष्ट नाव.",
      farmRegistrationId: "शेतीची नोंदणी क्रमांक.",
      farmLocation: "शेतीची विशिष्ट भौगोलिक समन्वय किंवा स्थान.",
      dimitraFermerId:
        "दिमित्रा प्रणालीमध्ये एका वैयक्तिक शेतकऱ्याशी संबंधित अद्वितीय ओळखकर्ता.",
      farmerName: "शेतीसाठी जबाबदार व्यक्तीची ओळख.",
      farmerRegistrationId: "शेतकऱ्याची नोंदणी क्रमांक.",
      assessmentNo: "मूल्यांकनासाठी दिलेले अद्वितीय क्रमांक.",
    },
    red: "लाल",
    Yellow: "पिवळा",
    transparent: "पारदर्शक",
    darkRed: "गडद केसरी",
    brightRed: "चमकणारा केसरी",
    orange: "संतरा",
    lightBlue: "हलका निळा",
    teal: "तोयसरी",
    zeroOrNegligibleProbability: "शून्य/नगण्य वनीकरणाची शक्यता",
    riskDetected: "जोखीम आढळले",
    zeroOrNegligibleRisk: "शून्य/नगण्य जोखीम",
        manuallyMitigated: "मॅन्युअली कमी केले",
    compliant: "अनुपालक",
    nonCompliant: "गैर-अनुपालक",
    veryLowProbability: "खूप निम्न वनीकरणाची शक्यता",
    lowProbability: "निम्न वनीकरणाची शक्यता",
    mediumProbability: "मध्यम वनीकरणाची शक्यता",
    highProbability: "उच्च वनीकरणाची शक्यता",
    veryHighProbability: "खूप उच्च वनीकरणाची शक्यता",
    locationName: "स्थानाचे नाव",
  },
  selectFarmers:"शेतकरी निवडा",
  farm: {
    farm: "शेत",
    farms: "शेते",
    farmName: "शेताचं नाव",
    farmType: "शेताचा प्रकार",
    farmSize: "शेताचा आकार",
    farmLocation: "शेताचे स्थान",
    farmAddress: "शेताचा पत्ता",
    farmRegistrationId: "शेतीची नोंदणी क्रमांक",
    farmLatitude: "शेती अक्षांश",
    farmLongitude: "शेती रेखांश",
    farmOwner: "शेताचे मालक",
    farmOwnerName: "शेताचे मालकाचे नाव",
    farmOwnerPhone: "शेताचे मालकाचा फोन नंबर",
    farmOwnerEmail: "शेताचे मालकाचा ईमेल",
    farmOwnerAddress: "शेताचे मालकाचा पत्ता",
    farmOwnerRegistrationId: "शेताचे मालकाची नोंदणी क्रमांक",
    farmOwnerLatitude: "शेताचे मालकाचा अक्षांश",
    farmOwnerLongitude: "शेताचे मालकाचा रेखांश",
    farmOwnerNationalId: "शेताचे मालकाचा राष्ट्रीय आयडी",
    farmOwnerNationalIdType: "शेताचे मालकाचा राष्ट्रीय आयडी प्रकार",
    farmOwnerNationalIdImage: "शेताचे मालकाचा राष्ट्रीय आयडी चित्र",
    activities: "क्रियाकलाप",
    "search": "शोध",
    "selectCountry": "देश निवडा",
    "filterByFarmName": "शेताच्या नावानुसार फिल्टर करा",
    "filterByCropType": "फसळ प्रकारानुसार फिल्टर करा",
    "filterByStartDate": "सुरुवातीच्या तारखेनुसार फिल्टर करा",
    "download": "डाउनलोड",
    "of": "च्या",
    "previousPage": "मागील पृष्ठ",
    "nextPage": "पुढील पृष्ठ",
    "view": "पहा",
    "activityDetails": "क्रियाकलापाचा तपशील",
    "activity": "क्रियाकलाप",
    "cropType": "फसळ प्रकार",
    "startDate": "सुरुवातीची तारीख",
    "endDate": "समाप्तीची तारीख",
    "description": "वर्णन",
    "close": "बंद करा",
    "farmActivities": "शेतीचे क्रियाकलाप",  
    "listView": "यादी पहा",
    "calendarView": "कॅलेंडर पहा",
    "scheduledActivities": "नियोजित क्रियाकलाप",
    "completedActivities": "पूर्ण केलेले क्रियाकलाप",
  },
  pleaseAgreeToDeclaration: "कृपया निष्कर्ष काढण्यासाठी घोषणेशी सहमत व्हा.",
  importProductionPlaceTT: "फाइल अपलोड किंवा डाउनलोड पर्यायांचा वापर करून उत्पादन स्थान डेटा आयात करण्याची परवानगी देते.",
  defaultCircularGeofence: "ज्या शेतांमध्ये जिओफेन्स नाही किंवा त्यांच्या आकाराबद्दल माहिती नाही त्यांना ४ हेक्टरचा डिफॉल्ट सर्कुलर जिओफेन्स दिला जाईल. जर सरासरी शेताचा आकार ४ हेक्टरपेक्षा लहान असेल, तर कृपया खालील 'संपादित करा' बटणावर क्लिक करून डिफॉल्ट आकार बदला.",
  accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "EUDR नुसार, ४ हेक्टरपेक्षा कमी क्षेत्रफळ असलेल्या शेतांना बहुभुजाची आवश्यकता नाही.",
  uploadOneDeforestationAssessmentForAllFarms: "सर्व शेतांसाठी एक वनोंत्पादन मूल्यांकन अपलोड करा",
  uploadAssessment: "मूल्यांकन अपलोड करा",
  noUploadToBlockchain: "ब्लॉकचेनवर अपलोड नाही",
  noDataForBlockchain: "उत्पादन स्थळांसाठी वनोंत्पादनाच्या अहवालांची निर्मिती झालेली नसल्यामुळे, ब्लॉकचेनवर लिहिण्यासाठी कोणतेही डेटा नव्हते. हे अपेक्षित नसल्यास, कृपया खात्री करा की मागील टप्प्यांमध्ये शेतांसाठी अहवाल योग्यरित्या तयार केले गेले आहेत."
};
